import React from 'react';

import { FormControl, Box, FormHelperText, TextField } from '@mui/material';
import type { FormFieldProps } from '@/types';

export default function AccountFirstNameField({
  value,
  error,
  setValue,
  setError,
}: FormFieldProps) {
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { value: newValue } = event.target;
    setValue(newValue);
    if (/[#^$<>+%!`&*'"|{}?/\\:=@]/.test(newValue)) {
      setError('First name cannot contain #^$<>+%!`&*\'"|{}?/\\:=@');
    } else if (newValue === '') {
      setError('First name cannot be blank');
    } else {
      setError(false);
    }
  };

  return (
    <Box>
      <FormControl fullWidth required>
        <TextField
          label='First Name'
          id='first_name'
          aria-describedby='first-name-helper-text'
          onChange={handleChange}
          error={Boolean(error || value === '')}
          value={value}
          variant='standard'
          required
        />
        {error ? (
          <FormHelperText id='first-name-helper-text'>{error}</FormHelperText>
        ) : (
          <FormHelperText id='first-name-helper-text'>
            Enter your given name
          </FormHelperText>
        )}
      </FormControl>
    </Box>
  );
}

